import { useDispatch, useSelector } from "react-redux";
import Container from "../element/container";
import Col from "../element/col";
import Row from "../element/row";
import CommonCart from "../common/common.cart";
import CommonSummary from "../common/common.summary";
import {
  closeCartDropdown,
  closeShopDropdown,
} from "../../redux/reducer/common.reducer";
import Image from "../element/image";
import { Skeleton } from "primereact/skeleton";
import useWindowDimension from "../hook/use.window.dimension";
import { useLocation, useNavigate } from "react-router-dom";

export default function ShopDropdown() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { width } = useWindowDimension();
  const { categoryList, categoryListLoading } = useSelector(
    (state) => state.common
  );

  const handleNavigate = (category) => {
    if (pathname.includes("/shop")) {
      navigate(`/shop/${category.toLowerCase()}#product-list`);
    } else {
      navigate(`/shop/${category.toLowerCase()}`);
    }
  };

  return (
    <Container
      className="shop-dropdown"
      onClick={(e) => e.stopPropagation()}
      onMouseLeave={() => {
        dispatch(closeShopDropdown());
      }}
    >
      <Col className="_col category-list">
        {categoryListLoading
          ? Array.from({ length: 4 }, (_, categoryLoadingIndex) => (
              <Row className="h-flex gap-4" key={categoryLoadingIndex}>
                <Skeleton
                  width={width < 991 ? "40px" : "50px"}
                  height={width < 991 ? "40px" : "50px"}
                  className="category-bg"
                />
                <Col>
                  <Skeleton
                    width="120px"
                    height={width < 991 ? "14px" : "16px"}
                    borderRadius="0"
                  />
                </Col>
              </Row>
            ))
          : categoryList?.length > 0 &&
            categoryList.map((category, categoryIndex) => (
              <Row
                className="_row category-item h-flex gap-4"
                key={categoryIndex}
                onClick={() => handleNavigate(category.name)}
              >
                <article className="category-bg">
                  <Image
                    src={category.media?.length > 0 && category.media[0].url}
                    className="_img"
                  />
                </article>
                <Col>
                  <h4 className="_label">{category.name}</h4>
                </Col>
              </Row>
            ))}
      </Col>
    </Container>
  );
}
